/**
 * Returns `url` with the query string and fragment stripped. Path stays — you
 * need it to know what endpoint was called — but everything after `?` or `#`
 * is dropped. Query params can carry customer identifiers (`email`, `nmi`,
 * `originAddressId`) so we don't log them, full stop.
 *
 *   `/api/cart?email=a@b.com&postcode=2222` → `/api/cart`
 *   `https://api.example.com/foo?a=1#x`     → `https://api.example.com/foo`
 */
export const redactUrl = (url?: string): string | undefined => (url ? url.split(/[?#]/)[0] : url);
